import React, { useContext, useEffect, useState } from 'react';
import { CompanyContext } from '../../../context/CompanyContext';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import StaticTimeFilter from '../../../VentoryUI/components/filters/StaticTimeFilter';
import { MetricEntityType, MetricFilter } from '../../../types/metrics/metricFilter';
import MetricChartNumber from './Metrics/MetricChartNumber';
import MetricChartBarStacked from './Metrics/MetricChartBarStacked';

interface OverviewMetricsProps {
  filter: MetricFilter;
  setFilter: (filter: MetricFilter) => void;
}

export default function OverviewMetrics({
  filter: overviewFilter,
  setFilter: setOverviewFilter,
}: OverviewMetricsProps) {
  const { currentCompany } = useContext(CompanyContext);

  const [filter, setFilter] = useState<MetricFilter>(
    new MetricFilter({
      companyIds: overviewFilter.companyIds,
    }),
  );

  const hasTasks = !!currentCompany.settings.featureToggles.tasks.tasks;
  const hasOrders = !!currentCompany.settings.featureToggles.orders.orders;
  const hasAssets = !!currentCompany.settings.featureToggles.assets.assets;

  useEffect(() => {
    setFilter({ ...filter, companyIds: overviewFilter.companyIds });
  }, [overviewFilter]);

  return (
    <div className='flex select-none flex-col gap-2'>
      <div className='flex gap-2'>
        <MetricChartNumber
          type={MetricEntityType.productMasterData}
          filter={overviewFilter}
          title={t(TranslationKey.productMasterData).plural.label}
        />
        <MetricChartNumber
          type={MetricEntityType.stockLocation}
          filter={overviewFilter}
          title={t(TranslationKey.stockLocation).plural.label}
        />
        <MetricChartNumber
          type={MetricEntityType.transaction}
          filter={overviewFilter}
          title={t(TranslationKey.transaction).plural.label}
        />
        {hasOrders && (
          <MetricChartNumber
            type={MetricEntityType.order}
            filter={overviewFilter}
            title={t(TranslationKey.order).plural.label}
          />
        )}
        {hasTasks && (
          <MetricChartNumber
            type={MetricEntityType.task}
            filter={overviewFilter}
            title={t(TranslationKey.task).plural.label}
          />
        )}
        {hasAssets && (
          <MetricChartNumber
            type={MetricEntityType.asset}
            filter={overviewFilter}
            title={t(TranslationKey.asset).plural.label}
          />
        )}
        <MetricChartNumber
          type={MetricEntityType.user}
          filter={overviewFilter}
          title={t(TranslationKey.user).plural.label}
        />
      </div>
      <div>
        <StaticTimeFilter filter={filter} setFilter={setFilter} />
      </div>
      <div className='flex select-none flex-col items-stretch gap-2'>
        <div className='flex gap-2'>
          <MetricChartNumber
            type={MetricEntityType.productTransaction}
            filter={filter}
            title={t(TranslationKey.productTransaction).plural.label}
          />
          {hasOrders && (
            <MetricChartNumber
              type={MetricEntityType.order}
              filter={filter}
              title={t(TranslationKey.order).plural.label}
            />
          )}
          {hasTasks && (
            <MetricChartNumber
              type={MetricEntityType.task}
              filter={filter}
              title={t(TranslationKey.task).plural.label}
            />
          )}
          {hasTasks && (
            <MetricChartNumber
              type={MetricEntityType.taskProduct}
              filter={filter}
              title={t(TranslationKey.productCount).plural.label}
            />
          )}
          {hasAssets && (
            <MetricChartNumber
              type={MetricEntityType.asset}
              filter={filter}
              title={t(TranslationKey.asset).plural.label}
            />
          )}
          {hasAssets && (
            <MetricChartNumber
              type={MetricEntityType.assetTransaction}
              filter={filter}
              title={t(TranslationKey.assetTransaction).plural.label}
            />
          )}
        </div>
        <div className='flex gap-2'>
          {/* <MetricChartBarStacked
            title={t(TranslationKey.numberOfTransactions).singular.label}
            type={MetricEntityType.transaction}
            filter={filter}
          /> */}
          <MetricChartBarStacked
            title={t(TranslationKey.numberOfActions).singular.label}
            type={MetricEntityType.action}
            filter={filter}
          />
        </div>
      </div>
    </div>
  );
}
